<template>
  <div
    class="choose-type"
    @click="handleToggleChoose"
  >
    <div
      v-clickoutside="handleCloseChoose"
      class="top"
    >
      <b class="name">{{ activeName }}</b>
      <i
        v-if="options && options.length"
        class="iconfont fs-gray"
        :class="{'iconicon-test17': !showChooseList, 'iconicon-test14': showChooseList}"
      />
    </div>
    <!-- 切换列表类型 -->
    <transition name="slide-up">
      <div
        v-show="showChooseList"
        ref="chooseList"
        class="choose-list"
      >
        <cell-list
          :data="options"
          :mask="true"
          @change="handleChangeChoose"
        >
          <template v-slot:item="{ data }">
            <div
              class="item"
              :class="{ 'checked': data.checked }"
            >
              <span class="name">{{ data.name }}</span>
              <span class="right">
                <i
                  v-if="data.checked"
                  class="iconfont iconicon-test16 fs-blue"
                />
                <!-- <i
                  v-else
                  class="iconfont icon-success gray"
                /> -->
              </span>
            </div>
          </template>
        </cell-list>
      </div>
    </transition>
  </div>
</template>

<script>
import CellList from '@/components/mobile/CellList'
import { clickoutside } from '@/lib/directives'

export default {
  directives: { clickoutside },
  components: {
    CellList
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showChooseList: false, // 选择框是否展示
      activeKey: this.value,
      activeName: ''
    }
  },
  created () {
    this.setDefault()
  },
  methods: {
    handleToggleChoose (e) {
      if (!this.options.length) return
      if (this.$refs.chooseList.contains(e.target)) return
      this.showChooseList = !this.showChooseList

      this.setDefault()
    },
    setDefault () {
      this.options.forEach(item => {
        if (item.key === this.activeKey) {
          this.activeName = item.name
          this.$set(item, 'checked', true)
        }
      })
    },
    handleCloseChoose (e) {
      this.showChooseList = false
    },
    handleChangeChoose (item, index) {
      this.options.forEach(item => {
        this.$set(item, 'checked', false)
      })
      this.$set(item, 'checked', true)
      this.activeKey = item.key
      this.activeName = item.name
      this.showChooseList = false

      this.$emit('change', this.activeKey)
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-type {
  > b.name {
    margin-right: 6px;
    font-size: 18px;
    font-weight: bold;
  }
}
.choose-list {
  position: fixed;
  top: 46px;
  left: 0;
  width: 100%;
  height: 200px;
  .item.checked {
    .name {
      color: $primary-color;
    }
  }
}
.cube-btn {
  width: 48%;
}
.slide-up-enter,
.slide-up-leave-active {
  -webkit-transform: translate3d(0, -200%, 0);
  transform: translate3d(0, -200%, 0);
}

.slide-up-enter-active,
.slide-up-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
